import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'vb-lxp-video-controls',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './video-controls.component.html',
  styleUrls: ['./video-controls.component.css'],
})
export class VbLxpVideoControlsComponent {
  @Input() time = '0:00:00';
  @Input() isLive = true;
  @Input() progressPercent = 55;
  @Input() volumePercent = 70;
  @Input() isPlaying = false;
  @Output() onTogglePlay = new EventEmitter<void>();
}
